import { render } from "./SaleModalFlatRatePaymentPlanBox.vue?vue&type=template&id=6dbcb5b8&scoped=true"
import script from "./SaleModalFlatRatePaymentPlanBox.vue?vue&type=script&lang=js"
export * from "./SaleModalFlatRatePaymentPlanBox.vue?vue&type=script&lang=js"

import "./SaleModalFlatRatePaymentPlanBox.vue?vue&type=style&index=0&id=6dbcb5b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbcb5b8"]])

export default __exports__